<template>
  <div>
    <div class="results-info-wrapper" v-if="pager && pager.totalPages > 1">
      <div class="row">
        <div class="col-5">
          <div
            class="dataTables_info"
            id="datatable-ecommerce-list_info"
            role="status"
            aria-live="polite"
          >
            Showing {{ fromResults }} to {{ toResults }} of
            {{ pager.totalItems }} entries
          </div>
        </div>
        <div class="col-7 mb-3 mb-lg-0">
          <nav>
            <ul
              class="pagination pagination-modern pagination-modern-spacing justify-content-end mb-0"
            >
              <li class="page-item" :class="{ disabled: prevDisabled }">
                <router-link
                  class="page-link prev"
                  :to="{
                    query: {
                      page: 1,
                      search: $route.query.search,
                      ...paginationProps,
                    },
                  }"
                >
                  <span>
                    <i class="fas fa-angle-double-left"></i>
                  </span>
                </router-link>
              </li>
              <li class="page-item" :class="{ disabled: prevDisabled }">
                <router-link
                  class="page-link prev"
                  :to="{
                    query: {
                      page: +currentRoute.query.page - 1,
                      search: $route.query.search,
                      ...paginationProps,
                    },
                  }"
                >
                  <span>
                    <i class="fas fa-chevron-left"></i>
                  </span>
                </router-link>
              </li>

              <li
                class="page-item"
                :class="{
                  active:
                    index == currentRoute.query.page ||
                    (index === 1 && !currentRoute.query.page),
                }"
                v-for="index in pages"
                :key="index"
              >
                <router-link
                  exact
                  class="page-link"
                  :to="{
                    query: {
                      page: index,
                      search: $route.query.search,
                      ...paginationProps,
                    },
                  }"
                >
                  {{ index }}
                </router-link>
              </li>

              <li class="page-item" :class="{ disabled: nextDisabled }">
                <router-link
                  class="page-link next"
                  :to="{
                    query: {
                      page: parseInt(currentRoute.query.page || 1, 10) + 1,
                      search: $route.query.search,
                      ...paginationProps,
                    },
                  }"
                >
                  <span>
                    <i class="fas fa-chevron-right"></i>
                  </span>
                </router-link>
              </li>
              <li class="page-item" :class="{ disabled: nextDisabled }">
                <router-link
                  class="page-link next"
                  :to="{
                    query: {
                      page: pager.totalPages,
                      search: $route.query.search,
                      ...paginationProps,
                    },
                  }"
                >
                  <span>
                    <i class="fas fa-angle-double-right" />
                  </span>
                </router-link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pager, translations } from '@/mixins';

export default {
  name: 'Pagination',
  data() {
    return {
      actionName: this.action,
    };
  },
  props: {
    action: String,
    paginationProps: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [pager, translations],
  computed: {
    currentRoute() {
      return this.$route;
    },
  },
  mounted() {
    if (this.$route.query.page) {
      const timerId = setTimeout(() => {
        this.firstLoad();
        clearTimeout(timerId);
      }, 0);
    }
  },
  watch: {
    '$route.query.page'(page) {
      page = page || 1;
      if (page === 1) {
        this.firstLoad();
      } else {
        this.goToPage(parseInt(page, 10));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-item:not(.disabled) {
  cursor: pointer;
}

.page-item.disabled {
  cursor: not-allowed;
}
</style>
